
export const columns = [
         {
           Header: "Profissional",
           align: "left",
           getValue: (row) => row?.profissionalSaude?.nome,
         },
         {
           Header: "Qtd. Agendamentos",
           align: "left",
           getValue: (row) => row.quantidadeAgendamentos,
         },
         {
           Header: "Total de valor a pagar",
           align: "left",
           getValue: (row) => row.valorTotalAPagar,
         },
         {
           Header: "Total de valor a receber",
           align: "left",
           getValue: (row) => row.totalAReceber,
         },
       ];